import { useEffect } from 'react';

const useFixScroll = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('visible-modal');
    } else {
      document.body.classList.remove('visible-modal');
    }

    return () => {
      document.body.classList.remove('visible-modal');
    };
  }, [isOpen]);
};

export default useFixScroll;
